import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import history from './history';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/reducers';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App store={store} />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

reportWebVitals();
